module.exports = __webpack_public_path__ + "media/images/icons/flags/LY-b040433c3f93819d4a4163a90bd55814.svg";